export default {
	root: {
		padding: '16px'
	}
};
